module.exports = "/*input {*/\n/*text-transform: none;*/\n/*}*/\n/*tag-input {*/\n/*text-transform: none;*/\n/*}*/\n/*textarea{*/\n/*text-transform: none;*/\n/*}*/\n/*.ng-tns-c13-1.ng2-tag-input.bootstrap3-info {*/\n/*height: 200px;*/\n/*}*/\n/*.ng-tns-c4-1.ng2-tag-input.bootstrap3-info {*/\n/*height: 150px;*/\n/*}*/"


//////////////////
// WEBPACK FOOTER
// ./src/app/report/report.component.css
// module id = ./src/app/report/report.component.css
// module chunks = main